import type { FaireProductEntity } from "../../entity_types/product";

export const p_5mgevtjb: FaireProductEntity = {
  token: "p_5mgevtjb",
  type: "product",
  name: "Grazie Thank You Greeting Card",
  brandToken: "b_6pxaaxfg",
  brandName: "La Familia Green",
  imageUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/ca8158e04c8b4ca98044d3b93b1017fd9040acb0844466844f74bc516541b448/1535728726.jpg",
  galleryImageUrls: [],
  priceDollars: 3,
  description:
    'Grazie is Italian for thanks. And spaghetti is Italian for yum.\n\n• Flat printed on FSC certified paper from an original handcut collage, drawing, or print.\n• 4.25" x 5.5" folded card with recycled kraft envelope.\n• Blank inside\n• Made in USA',
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:53:30.593Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
